import React from 'react';
import { Box, Button, TextField } from '@mui/material';

function SearchBar({ searchTerm, onSearchTermChange, onSearchClick }) {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: 'minmax(0, 1fr) auto' },
                gap: 1,
                alignItems: 'center',
                mb: 2,
            }}
        >
            <TextField
                size="small"
                label="Search terms"
                value={searchTerm}
                onChange={(e) => onSearchTermChange(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') onSearchClick();
                }}
                fullWidth
            />
            <Button variant="contained" onClick={onSearchClick} sx={{ minHeight: 40 }}>
                Search
            </Button>
        </Box>
    );
}

export default SearchBar;
